import $ from 'jquery';
import utils from '../../framework/js/app.utils';
import anime from 'animejs';

let componentNavigationBreadcrumbs = {
  init() {
    const contextAttr = '.component-navigation--breadcrumb';

    let contextElmExists = utils.elementsExist(contextAttr);

    if (!contextElmExists) return false;

    const $context = utils.returnJqueryElement(contextAttr);

    let $items = $context.find('.link-item');
    let $lastitem = $context.find('.current');

    let handleWidth = () => {
      let containerWidth = $context.width();
      let combinedItemWidth = 0;
      let widthOfFirstItems = 0;

      if (utils.currentBreakpoint('medium')) {
        
      }


      $items.each((i, e) => {
        let $item = $(e);
        $item.find('.text').removeClass('truncate');
        $item.find('.text').width($item.find('.text').width());
        combinedItemWidth += $item.width();
        if (!$item.hasClass('current')) {
          widthOfFirstItems += $item.width();
        }
      });
  
      if (combinedItemWidth > containerWidth) {
        let widthLeft = containerWidth - widthOfFirstItems - 10;
        if (widthLeft > 0) {
          $lastitem.find('.text').addClass('truncate');
          $lastitem.find('.text').width(widthLeft);
        }
        else {
          widthLeft = containerWidth - widthOfFirstItems + $lastitem.prev().width() - 30;
          $lastitem.hide();
          $lastitem.prev().find('a').find('span').addClass('truncate');
          if (utils.currentBreakpoint('smedium', 'down')) {
            let contextWidth = $context.width();
            $lastitem.prev().find('a').find('span').width(contextWidth - 20);
            $lastitem.prev().find('a').width(contextWidth - 20);
          }
          else {
            $lastitem.prev().find('a').find('span').width(widthLeft);
            $lastitem.prev().find('a').width(widthLeft);
          }
        }
      }
  
      anime({
        targets: '.component-navigation--breadcrumb',
        opacity: [0, 1],
        duration: 2000,
        delay: anime.stagger(100)
      });
    }

    handleWidth();

    $(window).resize(() => {
      $context.css('opacity', '0');
      handleWidth();
    });
  },
};

export default componentNavigationBreadcrumbs;
